import { render, staticRenderFns } from "./lawsuit_3.vue?vue&type=template&id=49bc77e1&scoped=true"
import script from "./lawsuit_3.vue?vue&type=script&lang=js"
export * from "./lawsuit_3.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_3.vue?vue&type=style&index=0&id=49bc77e1&prod&scoped=true&lang=less"
import style1 from "./lawsuit_3.vue?vue&type=style&index=1&id=49bc77e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc77e1",
  null
  
)

export default component.exports